import { apiGet, apiPatch, apiDelete } from './config';

export default class ApprovalsApi {
    static async FetchAll() {
        const query = `approvals?limit=1000`;

        return apiGet(query);
    }

    /**
     * @description Fetches Approvals with Custom Filters
     * @param {{status: string, search: string, page: number, rowsPerPage: number, approvalTypeFilter: string }} query Custom Filters
     * @param {string} query.status Approval Status ( approved | pending | denied ), defaults to pending.
     * @param {string} query.search Search Term
     * @param {number} query.page Page number defaults to 0.
     * @param {number} query.rowsPerPage Rows Per Page defaults to 50.
     * @param {string} query.approvalTypeFilter Filters Approval Type, defaults to 'All'.
     * @return  {object} Object with .data having a list of all Approvals and their attributes
     */
    static async FetchApprovalsByCustomFilter({
        search = '',
        status = 'pending',
        page = 0,
        rowsPerPage = 50,
        approvalTypeFilter = 'All',
    }) {
        let query = `approvals?status=${status}&page=${page + 1}&limit=${rowsPerPage}`;

        if (search !== '') {
            query += `&search=${encodeURIComponent(search)}`;
        }

        if (approvalTypeFilter && approvalTypeFilter !== 'All') {
            query += `&approval_type=${approvalTypeFilter}`;
        }

        return apiGet(query);
    }

    static async Update({ approvalId, data }) {
        return apiPatch(`approvals/${approvalId}`, { approval: data });
    }

    static async Delete(approvalId) {
        return apiDelete(`approvals/${approvalId}`);
    }

    static async CountPending() {
        return apiGet('approvals?status=pending&count=1');
    }
}
